import axios from "axios";

const apiClient = axios.create({
  baseURL: import.meta.env.VITE_BACKEND_URL + "/api",
  timeout: 10000,
  headers: { "Content-Type": "application/json" },
});

// Request interceptor to add token
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("authToken");

    if (token) config.headers.Authorization = `Bearer ${token}`;

    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor to return only data
apiClient.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("authToken");

      if (window.location.pathname !== "/") {
        window.location.href = "/";
      }
    }

    return Promise.reject(error);
  }
);

const http = {
  async get(url, params = {}, headers = {}) {
    return await apiClient.get(url, { params, headers });
  },

  async post(url, data = {}, headers = {}) {
    return await apiClient.post(url, data, { headers });
  },

  async put(url, data = {}, headers = {}) {
    return await apiClient.put(url, data, { headers });
  },

  async patch(url, data = {}, headers = {}) {
    return await apiClient.patch(url, data, { headers });
  },

  async del(url, headers = {}) {
    return await apiClient.delete(url, { headers });
  },
};

export default http;
